import React from 'react';
import moment from 'moment';
import useTranslation from '../../../../../../../../hooks/translation/useTranslation';

const tableTitleClass = 'm-0 items-center flex text-base';

function PurchasedTicketPanelHeader({ ticketsGroup, titlesRef }) {
  const { currentLanguage } = useTranslation();
  const ticket = ticketsGroup[0];
  return (
    <div className="flex justify-between">
      <div className="flex gap-5">
        <h3
          className={`${tableTitleClass}`}
          style={{
            width: titlesRef?.current?.children?.[0]?.clientWidth,
          }}
        >
          {ticket.statement.statement_id}
        </h3>
        <h3
          className={`${tableTitleClass} `}
          style={{
            width: titlesRef?.current?.children?.[1]?.clientWidth,
          }}
        >
          {ticket.train_number}
        </h3>
        <h3
          className={`${tableTitleClass}`}
          style={{
            width: titlesRef?.current?.children?.[2]?.clientWidth,
          }}
        >
          {ticket.ticket_start_station?.[`name_${currentLanguage === 'am' ? 'ka' : currentLanguage}`] || ticket.ticket_start_station.name}
        </h3>
        <h3
          className={`${tableTitleClass}`}
          style={{
            width: titlesRef?.current?.children?.[3]?.clientWidth,
          }}
        >
          {ticket.ticket_end_station?.[`name_${currentLanguage === 'am' ? 'ka' : currentLanguage}`] || ticket.ticket_end_station.name}
        </h3>
        <h3
          className={`${tableTitleClass}`}
          style={{
            width: titlesRef?.current?.children?.[4]?.clientWidth,
          }}
        >
          {moment(ticket.departure_date).format('DD.MM.YYYY HH:mm')}
        </h3>
        <h3
          className={`${tableTitleClass}`}
          style={{
            width: titlesRef?.current?.children?.[5]?.clientWidth,
          }}
        >
          {moment(ticket.arrival_date).format('DD.MM.YYYY HH:mm')}
        </h3>
      </div>
    </div>
  );
}

export default PurchasedTicketPanelHeader;
